export default function FounderQuoteSection() {
    return (
        <section className="py-16 md:py-20 bg-[#F7F5F0]" data-testid="founder-quote-section">
            <div className="max-w-4xl mx-auto px-6 text-center">
                <svg
                    aria-hidden
                    className="h-10 w-10 mx-auto text-[#C8A24A] mb-6"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M9.13 8.74A5.86 5.86 0 0 0 3.27 14.6v2.93h5.86V11.67H6.2a3 3 0 0 1 2.93-2.93v-.0zM20.73 8.74a5.86 5.86 0 0 0-5.86 5.86v2.93h5.86V11.67h-2.93a3 3 0 0 1 2.93-2.93z" />
                </svg>
                <blockquote
                    className="font-[Outfit] text-2xl sm:text-3xl font-medium leading-[1.3] tracking-tight text-[#1A2230] max-w-3xl mx-auto"
                    data-testid="referrals-founder-quote"
                >
                    "Every referral represents a young man deserving of
                    safety, stability, and the opportunity for growth."
                </blockquote>
                <p className="mt-6 text-[12.5px] tracking-[0.16em] uppercase text-[#6F6B63] font-medium">
                    Dorothy Summage &amp; Valerie Payton · Founder &amp; CEO
                </p>
            </div>
        </section>
    );
}
